<style scoped>
  .btn-group {
    padding-left: 20px;
  }
</style>
<template>
  <div class="knowledge_query">
    <RadioGroup size="large" v-model="activeBtn" type="button" style="margin-bottom: 20px;">
      <Radio label="systemSet">系统设置</Radio>
      <Radio label="systemInfo">系统信息</Radio>
      <Radio label="roleManage">角色管理</Radio>
      <Radio label="historyList">操作记录</Radio>
    </RadioGroup>
    <Card>
      <system-set v-show="activeBtn=='systemSet'"></system-set>
      <system-info v-show="activeBtn=='systemInfo'"></system-info>
      <role-manage v-show="activeBtn=='roleManage'"></role-manage>
      <history-list v-show="activeBtn=='historyList'"></history-list>
    </Card>
  </div>
</template>
<script>
  import systemSet from "./component/system-set.vue";
  import systemInfo from "./component/system-info.vue";
  import roleManage from "./component/role-manage.vue";
  import historyList from "./component/history-list.vue";
  export default {
    name:'sysMain_page',
    data() {
      return{
        activeBtn:'systemSet'
      }
    },
    components: {
      systemSet,
      systemInfo,
      roleManage,
      historyList
    },
    methods:{

    }
  }
</script>






